import React from 'react';
import cls from 'classname';

const Orders = ({className}) => (
  <svg width="24"
       height="24"
       fill="#707BA0"
       className={cls('icon icon-orders', className)}
       viewBox="0 0 24 24"
       xmlns="http://www.w3.org/2000/svg"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M3.02447 11.4505C2.7556 9.07808 4.61147 7 6.99903 7H17.0006C19.3882 7 21.244 9.07808 20.9752 11.4505L20.2952 17.4504C20.066 19.4723 18.3555 21 16.3206 21H7.67903C5.64418 21 3.93362 19.4724 3.70447 17.4504L3.02447 11.4505ZM6.99903 9C5.80525 9 4.87731 10.039 5.01175 11.2252L5.69175 17.2252C5.80632 18.2362 6.6616 19 7.67903 19H16.3206C17.338 19 18.1933 18.2362 18.3079 17.2252L18.9879 11.2252C19.1223 10.039 18.1944 9 17.0006 9H6.99903Z" fill="#707BA0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7V10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10V7C14 5.89543 13.1046 5 12 5C10.8954 5 10 5.89543 10 7V10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10V7Z" fill="#707BA0"/>
  </svg>
);

export default Orders;
